/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable max-len */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import SmileScanMobile from '@brands/Dashboard/Dashboard/Patient/utils/smile_scan_mobile.svg';
import uploadImage from '@brands/Dashboard/PatientForms/PatientForm/ImageUpload/assets/drag-image-icon.svg';
import useSubscribe, { Subscriber } from '@brands/hooks/useSubscribe';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { setUserWebState } from '@brands/services/auth/setUserWebState';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectCurrentPatientState } from '@brands/store/selectors/currentPatientState';
import { selectOrganization } from '@brands/store/selectors/organization';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { setForm } from '@brands/store/slices/patientFormSlice';
import CancelIcon from '@mui/icons-material/Cancel';
import store from '@brands/store/store';
import { displayErrorDetails } from '@brands/Utils/displayError';
import Cookies from 'js-cookie';
import queryString from 'query-string';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import QRCode from 'react-qr-code';
import { useLocation, useNavigate } from 'react-router-dom';

import Button from '../../../../Components/Button/Button';
import Container from '../../../../Components/Container/Container';
import ProgressBar from '../../../../Components/ProgressBar/ProgressBar';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useReduxHook';
import useWindowSize from '../../../../hooks/useWindowSize';
import MobileHandoffModal from './Components/MobileHandoffModal';
import styles from './styles.module.scss';
import SelectInput from '@brands/Components/Inputs/SelectInput/SelectInput';
import { selectCommonCustomStylesSlim } from '@brands/Utils/customStyles';
import { red } from '@mui/material/colors';

type Option = {
  value: any;
  label: string;
};

interface UploadedFile {
  name: string;
  dataURL: string;
}

const ImageUploadWeb = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const screenSize = useWindowSize();
  const { state, search } = useLocation();
  const isMobile = screenSize.width < 768;
  const { userInfo } = useAppSelector(selectAuth);
  const [useintraoralCamera, setUseIntraoralCamera] = useState(false);
  const { currentOrganization } = useAppSelector(selectOrganization);
  const { currentOrganizationPrices } = useAppSelector(selectOrganizationPrices);
  const [loading, setLoading] = useState(false);
  const [displayMobileHandOffModal, setDisplayMobileHandOffModal] = useState(false);
  const queryParams = useMemo(() => queryString.parse(search), [search]);
  const { values, selectedPatient } = useAppSelector(selectPatientForm);
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);
  const currentState: Record<number, string> = useAppSelector(selectCurrentPatientState);
  const [cameraDevices, setCameraDevices] = useState<MediaDeviceInfo[]>([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(null);
  const [capturedImages, setCapturedImages] = useState<string[]>([]);
  const videoRef = useRef<HTMLVideoElement>(null);
  const caseType = values.find((item) => item.form_question_id === 20)?.value.caseType as string;
  const shouldShowButton = useintraoralCamera || (caseType !== 'one_report' && caseType !== 'second_opinion');
  const updateCameraDevices = useCallback(async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter((d) => d.kind === 'videoinput');

      setCameraDevices(videoDevices);

      if (videoDevices.length > 0) {
        if (!selectedDeviceId || !videoDevices.some((device) => device.deviceId === selectedDeviceId)) {
          setSelectedDeviceId(videoDevices[0].deviceId);
        }
      } else {
        setSelectedDeviceId(null); // No devices available
      }

      // Stop the temporary stream used for enumeration
      stream.getTracks().forEach((track) => track.stop());
    } catch (err) {
      console.error('Error enumerating devices:', err);
      setCameraDevices([]);
      setSelectedDeviceId(null);
    }
  }, [selectedDeviceId]);

  // Initialize camera devices and set up devicechange listener
  useEffect(() => {
    if (!useintraoralCamera) return;

    updateCameraDevices();

    navigator.mediaDevices.addEventListener('devicechange', updateCameraDevices);

    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', updateCameraDevices);
    };
  }, [useintraoralCamera, updateCameraDevices]);

  useEffect(() => {
    if (!useintraoralCamera || !selectedDeviceId) return;

    const startVideoStream = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: { exact: selectedDeviceId } },
        });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play().catch((err) => console.error('Error playing video:', err));
        }
      } catch (err) {
        console.error('Error accessing camera:', err);
      }
    };

    startVideoStream();

    return () => {
      if (videoRef.current?.srcObject instanceof MediaStream) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
        videoRef.current.srcObject = null;
      }
    };
  }, [selectedDeviceId, useintraoralCamera]);

  const captureImage = () => {
    if (!videoRef.current) return;
    const canvas = document.createElement('canvas');
    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
      const imageUrl = canvas.toDataURL('image/png');
      setCapturedImages([...capturedImages, imageUrl]);
    }
  };

  const deleteImage = (index: number) => {
    const updatedImages = [...capturedImages];
    updatedImages.splice(index, 1);
    setCapturedImages(updatedImages);
  };

  const cameraOptions: Option[] = cameraDevices.map((device) => ({
    value: device.deviceId,
    label: device.label || 'Camera',
  }));

  const [newUrl, setNewUrl] = useState('');

  const subscriber: Subscriber = useMemo(
    () => ({
      onMessage: (message: Record<string, any>) => {
        if (['mobile_handoff'].includes(message.command)) {
          setDisplayMobileHandOffModal(true);
        } else if (['mobile_case_creation_complete'].includes(message.command)) {
          setDisplayMobileHandOffModal(false);
          goToDashboard();
        }
      },
      commands: ['mobile_handoff', 'mobile_case_creation_complete'],
    }),
    [setDisplayMobileHandOffModal],
  );
  const { subscribe, unsubscribe } = useSubscribe();

  useEffect(() => {
    const subscriptionId = subscribe(subscriber);

    return () => unsubscribe(subscriptionId);
  }, [subscribe, unsubscribe, subscriber]);

  useEffect(() => {
    const painQuestion = values.find((item) => item.form_question_id === 16)?.value;

    const isPainValid = () => {
      if (!painQuestion) return false;

      const { painLevel, describePain, daysInPain } = painQuestion;

      if (!painLevel) return false;

      if (painLevel !== 'noPain' && (!describePain || (describePain as string[]).length === 0)) return false;

      if (painLevel !== 'noPain' && !daysInPain) return false;

      return true;
    };

    if (!isPainValid()) {
      navigate('/describe-pain-level');
    }
  }, [values]);

  const appendStateToUrl = (jwtToken: string): string => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);

    // Set the 'auth' parameter with the JWT token
    url.searchParams.set('auth', encodeURIComponent(jwtToken));

    return url.toString();
  };

  const goToDashboard = useCallback(() => {
    if (
      userInfo.role.name === UserRoleName.Admin ||
      userInfo.role.name === UserRoleName.SuperAdmin ||
      userInfo.role.name === UserRoleName.OrganizationAdmin
    ) {
      navigate(`/admin/review-profile/Patient/${state.patientId}`);
    } else {
      navigate('/dashboard');
    }
  }, [userInfo.role.name, navigate]);

  useEffect(() => {
    const fetchDataAndSetState = async (): Promise<void> => {
      setLoading(true);
      if (!queryParams.state) {
        // Retrieve and compress the Redux state
        const reduxState = store.getState();

        // Extract only the needed parts
        const { auth, pageState } = reduxState;

        // Create a new object with the selected parts
        const selectedState = {
          auth,
          patientForm: reduxState.patientForm,
          selectedPatient: currentPatient,
          pageState,
          patientcurrentOrganization: currentOrganization,
          patientcurrentOrganizationPrices: currentOrganizationPrices,
          refreshToken: Cookies.get('refreshToken'),
          jwtTokenExpire: Cookies.get('jwtTokenExpire'),
          patientState: !(
            userInfo.role.name === UserRoleName.Admin ||
            userInfo.role.name === UserRoleName.SuperAdmin ||
            userInfo.role.name === UserRoleName.OrganizationAdmin
          )
            ? userInfo.id in currentState
              ? { [userInfo.id]: currentState[userInfo.id] }
              : {}
            : { [currentPatient?.id]: currentState[currentPatient?.id] },
        };

        // Set User Web State
        try {
          await setUserWebState(selectedState);
        } catch (error: unknown) {
          displayErrorDetails(error);
        }

        setNewUrl(appendStateToUrl(Cookies.get('jwtToken') as string));
        setLoading(false);
      }
    };
    if (queryParams.auth === undefined) {
      fetchDataAndSetState();
    }
  }, [queryParams]);

  const onBack = (): void => {
    if (useintraoralCamera) {
      const videoElement = document.querySelector('video');
      const stream = videoElement?.srcObject as MediaStream | null;

      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
      setUseIntraoralCamera(false);
    } else {
      dispatch(setForm([...values!]));
      navigate(-1);
    }
  };

  const movetoNextPage = (): void => {
    const uploadedFiles: UploadedFile[] = capturedImages.map((dataURL, index) => ({
      name: `Capture-${index + 1}.png`,
      dataURL,
    }));

    const existingAnswer = values!.find((item) => item.form_question_id === 17);
    const existingImages = (existingAnswer?.value?.images ?? []) as UploadedFile[];

    const allImages = [...existingImages, ...uploadedFiles];

    const filteredPayload = values!.filter((item) => item.form_question_id !== 17);

    filteredPayload.push({
      form_question_id: 17,
      value: { images: allImages },
    });

    dispatch(setForm(filteredPayload));

    const videoElement = document.querySelector('video');
    const stream = videoElement?.srcObject as MediaStream | null;

    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
    }
    setUseIntraoralCamera(false);

    navigate('/upload-image-flow');
  };

  if (loading) {
    return <Loading fullScreen />;
  }
  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
      }}
      childrenStyle={{ zIndex: '2' }}
    >
      <div className={styles.uploadImageContainer}>
        <div className={styles.uploadImageContainerDiv}>
          <ProgressBar currentStep={3} totalSteps={4} onBack={onBack} hideStepNumbers />
          {!useintraoralCamera ? (
            <>
              <div className={`${styles.formTitle} d-flex mt-3 fs-unmask`}>
                {(values.find((item) => item.form_question_id === 20)?.value.caseType as string) === 'one_report' ||
                (values.find((item) => item.form_question_id === 20)?.value.caseType as string) === 'second_opinion'
                  ? (values.find((item) => item.form_question_id === 20)?.value.caseType as string) === 'one_report'
                    ? 'Image upload'
                    : 'Attachment Upload *'
                  : 'Image upload'}
              </div>
              <div className={styles.uploadImageQRContainer}>
                <div>
                  {' '}
                  <img className={styles.smileScanMobile} src={SmileScanMobile} alt="SmileScanMobile" />
                </div>
                <div className={styles.uploadImageQRContainerText}>
                  <span className={`fs-unmask ${styles.uploadImageQRContainerText1}`}>
                    Use Our Guided Image Capture
                  </span>
                  <span className={`fs-unmask ${styles.uploadImageQRContainerText2}`}>
                    For a more seamless experience continue from your phone
                  </span>
                  <span className={`fs-unmask ${styles.uploadImageQRContainerText3}`}>
                    Use the QR code to get started.
                  </span>
                </div>
                <div className="fs-exclude">
                  <QRCode value={newUrl} size={150} />
                </div>
              </div>
              <div className={styles.uploadImageQRFooter}>
                <div>
                  <img
                    className={`fs-unmask ${styles.uploadImageQRFooterImage}`}
                    src={uploadImage}
                    alt="Upload Imahe"
                  />
                </div>
                <div className={`fs-unmask ${styles.uploadImageQRFooterText}`}>
                  <span className={styles.clickHere}>
                    <a onClick={() => navigate('/upload-image-flow')}>Click Here</a>
                  </span>{' '}
                  to upload images of your mouth and teeth from your computer.
                </div>
              </div>
              {!isMobile &&
                (userInfo.role.name === UserRoleName.Admin ||
                  userInfo.role.name === UserRoleName.SuperAdmin ||
                  userInfo.role.name === UserRoleName.OrganizationAdmin) && (
                  <div className={`fs-unmask ${styles.uploadImageIntraoralCamera}`}>
                    <span>
                      If you’re a provider using an intraoral camera to capture these images,{' '}
                      <a onClick={() => setUseIntraoralCamera(true)}>click here.</a>
                    </span>
                  </div>
                )}
            </>
          ) : (
            <div className={`fs-unmask ${styles.previewSection}`}>
              <video ref={videoRef} autoPlay playsInline muted />
              <div className={`fs-unmask ${styles.imageStrip}`}>
                {capturedImages.map((img, i) => (
                  <div className={`fs-unmask ${styles.imageWrapper}`} key={i}>
                    <img src={img} alt={`Capture ${i + 1}`} />
                    <CancelIcon
                      sx={{ color: red }}
                      className={`fs-unmask ${styles.delete}`}
                      onClick={() => deleteImage(i)}
                    />
                  </div>
                ))}
              </div>
              <button className={`fs-unmask ${styles.captureButton}`} onClick={captureImage}>
                <CameraAltIcon />
              </button>
              <div className={`fs-unmask ${styles.cameraSelector}`}>
                <SelectInput
                  name="camera"
                  options={cameraOptions}
                  style={selectCommonCustomStylesSlim}
                  containerClass={styles.inputWrapper}
                  selectorClass={styles.selector}
                  selectedValue={cameraOptions.find((opt) => opt.value === selectedDeviceId)}
                  onChange={(value) => {
                    setSelectedDeviceId(value?.value);
                  }}
                  isClearable={false}
                />
              </div>
            </div>
          )}

          {shouldShowButton && (
            <div className={styles.btnContainer}>
              <Button
                type="button"
                style={{ width: '245px', height: '46px' }}
                onClick={() => {
                  if (!useintraoralCamera) {
                    navigate('/medical-information-summary', {
                      state: {
                        caseType: state
                          ? (values.find((item) => item.form_question_id === 20)?.value.caseType as string)
                          : '',
                        patientId: selectedPatient?.value || '',
                        shouldSeeLastModal: false,
                        fromPatientIntake: true,
                      },
                    });
                  } else {
                    movetoNextPage();
                  }
                }}
                disabled={useintraoralCamera && capturedImages.length === 0}
              >
                {useintraoralCamera ? 'Next' : 'Skip'}
              </Button>
            </div>
          )}
        </div>
        {displayMobileHandOffModal && <MobileHandoffModal />}
      </div>
    </Container>
  );
};
export default ImageUploadWeb;
